/**
 * 功能: 绘制elements选区的组件, 可以新增element的选区、清空、撤销和更换整个slide, slide大小自动适应屏幕分辨率
 */

<template lang="pug">
  div.selection-area
    div.canvas-box.clearfix
      div.canvas-painting.fl(:style="{width: sWidth + 'px', height: sHeight + 'px'}")
        canvas(id="cvs" ref="cvs" :width="sWidth" :height="sHeight"
        @mousedown="down" @mousemove="move" @mouseup="up")
        #operate-btn
          .operate-btn
            el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" type="primary" @click="clear('clear')") 清空
          .operate-btn
            el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" type="primary" @click="clear('revoke')") 撤销
          .operate-btn
            el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" type="primary" @click="clear('changeImage')") 更换
          .operate-btn
            el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" :type='isEdit ? "danger" : "primary"' @click="edit()") {{ !isEdit ? '编辑' : '完成' }}

</template>

<script>
import Enum from '@/apis/enum'

export default {
  name: 'Region',
  props: {
    imgUrl: String,
    layers: { // 绘制选区数据
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      sWidth: 0,
      sHeight: 0,
      yImg: null,
      colors: Enum.COLORS,
      isEdit: false,
      originX: 0,
      originY: 0,
      index: 0,
      range: 10,
      position: '', // 鼠标相对于选框的位置，对应9中鼠标样式，
      process: { },

      flag: false, // 是否点击
      currentPosition: { top: 0, left: 0, width: 0, height: 0 } // 当前绘制图形对象
    }
  },
  mounted () {
    const that = this
    this.process = {
      move: (x, y) => that.rectMove(x, y),
      'n-resize': (x, y) => that.rectN(x, y),
      's-resize': (x, y) => that.rectS(x, y),
      'w-resize': (x, y) => that.rectW(x, y),
      'e-resize': (x, y) => that.rectE(x, y),
      'nw-resize': (x, y) => { that.rectN(x, y); that.rectW(x, y) }, // 左上角缩放，即向上和向左
      'ne-resize': (x, y) => { that.rectN(x, y); that.rectE(x, y) }, // 右上角缩放，即向上和向右
      'sw-resize': (x, y) => { that.rectS(x, y); that.rectW(x, y) }, // 左下角缩放，即向下和向左
      'se-resize': (x, y) => { that.rectS(x, y); that.rectE(x, y) } // 右下角缩放，即向下和向右
    }
    const c = document.getElementById('cvs')
    that.ctx = c.getContext('2d')
    that.init()
    // 监听页面resize事件 重新绘制slide图片大小 响应式
    window.onresize = () => {
      return (() => {
        if (this.$refs.cvs) that.init()
      })()
    }
    this.$bus.on('resetDir', (element) => {
      this.onPreloadComplete(element)
    })
    document.onmouseup = function (event) {
      that.up()
    }
  },
  watch: {
    sWidth (newVal) {
      this.sWidth = newVal
    },
    sHeight (newVal) {
      this.sHeight = newVal
    },
    imgUrl () {
      this.init()
    },
    layers () {
      this.reShow()
    }
  },
  methods: {
    edit () {
      this.isEdit = !this.isEdit
      this.ctx.clearRect(0, 0, this.$refs.cvs.width, this.$refs.cvs.height)
      this.reShow()
    },
    init () {
      const c = document.getElementById('cvs')
      this.ctx.clearRect(0, 0, this.$refs.cvs.width, this.$refs.cvs.height)
      this.yImg = new Image()
      this.yImg.src = this.imgUrl

      // 按照屏幕大小 缩放
      this.sWidth = document.body.clientWidth * 0.65
      this.sHeight = document.body.clientHeight * 0.85
      // 重新绘制图片大小
      this.yImg.onload = () => {
        var ratio = this.yImg.width / this.sWidth
        var height = this.yImg.height / ratio
        if (height > this.sHeight) {
          ratio = height / this.sHeight
          height = this.sHeight
          this.sWidth = this.sWidth / ratio
        } else {
          this.sHeight = height
        }
        c.style.backgroundImage = 'url(' + this.yImg.src + ')'
        c.style.backgroundSize = `${this.sWidth}px ${this.sHeight}px`
        setTimeout(() => {
          this.reShow()
        }, 100)
      }
    },
    // 处理重绘
    reShow () {
      this.layers.forEach((ele, index) => {
        const item = this.convertToNum(ele, this.sWidth, this.sHeight)
        this.ctx.beginPath()
        this.ctx.strokeStyle = this.colors[index]
        this.ctx.rect(item.left, item.top, item.width, item.height)
        this.ctx.closePath()
        this.ctx.font = '60px bold 黑体'
        this.ctx.fillText(index + 1, item.left + item.width / 2 - 15, item.top + item.height / 2 + 15)
        this.ctx.stroke()
      })
    },
    // 绘制图形
    draw (x, y, w, h) {
      this.ctx.save()
      this.ctx.strokeStyle = this.colors[this.layers.length]
      this.ctx.setLineDash([5])
      this.ctx.clearRect(0, 0, this.$refs.cvs.width, this.$refs.cvs.height)
      this.ctx.strokeRect(x, y, w, h)
      this.ctx.restore()
    },

    // 检测画的矩形是否符合要求 (大小)
    // 小于画布大小的5% 则认为误操作
    fixDraw (pos) {
      const c = document.getElementById('cvs')
      const w = c.width * 0.05
      const h = c.height * 0.05
      if (w > Math.abs(pos.width) || h > Math.abs(pos.height)) {
        return false
      } else {
        return pos
      }
    },
    // 统一处理按键操作
    // 默认: 删除  clear: 清空选区  revoke: 撤销
    clear (oper) {
      this.ctx.clearRect(0, 0, this.$refs.cvs.width, this.$refs.cvs.height)
      if (oper === 'clear') {
        this.$emit('clear')
      } else if (oper === 'revoke') {
        this.$emit('revoke')
      } else if (oper === 'changeImage') {
        this.$emit('changeImage')
      }
      this.reShow()
    },
    // 数字转化为百分比
    // obj: 需要转化的对象 w: 计算后的页面宽度 h: 计算后的页面高度
    convertToPct (obj, w, h) {
      const item = {}
      const convertField1 = ['top', 'height']
      const convertField2 = ['left', 'width']
      for (const key of Object.keys(obj)) {
        if (convertField2.includes(key)) {
          item[key] = Number((obj[key] / w).toFixed(4))
        } else if (convertField1.includes(key)) {
          item[key] = Number((obj[key] / h).toFixed(4))
        }
      }
      return item
    },
    // 百分比转化为数字
    // obj: 需要转化的对象 w: 计算后的页面宽度 h: 计算后的页面高度
    convertToNum (obj, w, h) {
      const item = {}
      const convertField1 = ['top', 'height']
      const convertField2 = ['left', 'width']
      for (const key of Object.keys(obj)) {
        if (convertField2.includes(key)) {
          item[key] = obj[key] * w
        } else if (convertField1.includes(key)) {
          item[key] = obj[key] * h
        }
      }
      return item
    },
    // 鼠标按下事件, 记录按下的点
    down (e) {
      if (this.isEdit) {
        this.index = -1
        this.originX = e.offsetX
        this.originY = e.offsetY
        this.isHot(this.originX, this.originY)
        this.flag = true
        return
      }
      if (this.flag) return
      this.flag = true
      this.currentPosition.left = e.offsetX
      this.currentPosition.top = e.offsetY
      const { top, left } = this.currentPosition
      this.ctx.strokeRect(left, top, 0, 0)
    },
    // 鼠标移动事件, 在slide上滑动后记录选区
    move (e) {
      if (this.isEdit) {
        const x = e.offsetX
        const y = e.offsetY
        this.isHot(x, y)
        if (this.flag) {
          if (this.index === -1) return
          const moveX = e.offsetX - this.originX
          const moveY = e.offsetY - this.originY
          this.originX = e.offsetX
          this.originY = e.offsetY
          if (!this.position) return
          // 策略模式，根据不同的状态调用相应的方法
          this.process[this.position](moveX, moveY)
          this.ctx.clearRect(0, 0, this.$refs.cvs.width, this.$refs.cvs.height)
          this.reShow()
          return
        }
      }
      if (this.flag) {
        const { top, left, width, height } = this.currentPosition
        this.currentPosition.width = e.offsetX - left
        this.currentPosition.height = e.offsetY - top
        this.draw(left, top, width, height)
        this.reShow()
      }
    },
    // 数据抬起事件, 判断用户弹起时的坐标合不合法, 如果不合法,则提示用户, 否则记录抬起的点, 并且初始化点
    up () {
      if (this.isEdit) {
        this.index = -1
        this.position = ''
      } else {
        // 校验坐标是否合法
        if (this.flag && this.fixDraw(this.currentPosition)) {
          // 把从下向上或从右至左选取的选框重新定位为从上到下和从左到右
          const { top, left, width, height } = this.currentPosition
          this.currentPosition.top = height > 0 ? top : top - Math.abs(height)
          this.currentPosition.left = width > 0 ? left : left - Math.abs(width)
          this.currentPosition.width = Math.abs(width)
          this.currentPosition.height = Math.abs(height)
          const pos = this.convertToPct(this.currentPosition, this.sWidth, this.sHeight)
          this.$emit('add', pos)
        } else {
          const { width, height } = this.currentPosition
          if (width !== 0 && height !== 0) {
            this.$message({ type: 'warning', message: '所选区域太小, 请重新框选!' })
          }
        }
        this.currentPosition = { top: 0, left: 0, width: 0, height: 0 }
      }
      this.ctx.clearRect(0, 0, this.sWidth, this.sHeight)
      this.reShow()
      this.flag = false
      this.currentPosition = { top: 0, left: 0, width: 0, height: 0 }
    },
    isHot (x, y) {
      for (let index = 0; index < this.layers.length; index++) {
        const ele = this.layers[index]
        const w = Math.abs(ele.width) * this.sWidth
        const h = Math.abs(ele.height) * this.sHeight
        let t = ele.top * this.sHeight
        if (ele.height < 0) {
          t = (ele.top - Math.abs(ele.height)) * this.sHeight
        }
        let l = ele.left * this.sWidth
        if (ele.width < 0) {
          l = (ele.left - Math.abs(ele.width)) * this.sWidth
        }
        const pX = x - l
        const pY = y - t
        if (this.position && this.flag) return
        this.position = this.getPosition(pX, pY, w, h)
        if (this.position) {
          this.ctx.canvas.style.cursor = this.position
          if (this.index === -1) this.index = index
          break
        } else {
          this.ctx.canvas.style.cursor = 'default'
        }
      }
    },
    /**
     * 根据坐标点和长宽获取当前鼠标处于选框的位置
     * @author 郭世凯 2021-12-07
     * @param {number} x 相对于选框的x坐标
     * @param {number} y 相对于选框的y坐标
     * @param {number} w 选框的宽度，即选框相对于自身左上角的x坐标
     * @param {number} h 选框的高度，即选框相对于自身左上角的y坐标
     * @return {String} 编辑的形式 resize（8种）和move
     */
    getPosition (x, y, w, h) {
      let position = ''
      if (Math.abs(y) < this.range && Math.abs(x) < w) position += 'n'
      else if (Math.abs(y - h) < this.range && Math.abs(x) < w) position += 's'
      if (Math.abs(x) < this.range && Math.abs(y) < h) position += 'w'
      else if (Math.abs(x - w) < this.range && Math.abs(y) < h) position += 'e'
      position = position ? position + '-resize' : position
      if (y > 0 && y < h - this.range && x > 0 && x < w - this.range) position = 'move'
      return position
    },
    /**
     * 移动选框方法
     * @author 郭世凯 2021-12-07
     * @param {number} x 移动的x距离
     * @param {number} y 移动的y距离
     */
    rectMove (x, y) {
      const percent = this.convertToPct({ top: y, left: x }, this.sWidth, this.sHeight)
      const { top, left, height, width } = this.layers[this.index]
      const t = top + percent.top
      const l = left + percent.left
      this.layers[this.index].top = t < 0 ? 0 : ((t + height) > 1 ? top : t)
      this.layers[this.index].left = l < 0 ? 0 : ((l + width) > 1 ? left : l)
    },
    /**
     * 选框最上方边的缩放方法 只与y轴移动有关
     * @author 郭世凯 2021-12-07
     * @param {number} x 移动的x距离
     * @param {number} y 移动的y距离
     */
    rectN (x, y) {
      const percent = this.convertToPct({ top: y }, this.sWidth, this.sHeight)
      const { top, height } = this.layers[this.index]
      const t = top + percent.top
      const h = height - percent.top
      if (h > (2 * this.range / this.sHeight) && (t + height) < 1) {
        this.layers[this.index].top = t < 0 ? 0 : t
        this.layers[this.index].height = h
      }
    },
    /**
     * 选框最下方边的缩放方法 只与y轴移动有关
     * @author 郭世凯 2021-12-07
     * @param {number} x 移动的x距离
     * @param {number} y 移动的y距离
     */
    rectS (x, y) {
      const percent = this.convertToPct({ height: y }, this.sWidth, this.sHeight)
      const { top, height } = this.layers[this.index]
      const h = height + percent.height
      if (h > (2 * this.range / this.sHeight)) this.layers[this.index].height = h + top > 1 ? height : h
    },
    /**
     * 选框最左侧边的缩放方法 只与x轴移动有关
     * @author 郭世凯 2021-12-07
     * @param {number} x 移动的x距离
     * @param {number} y 移动的y距离
     */
    rectW (x, y) {
      const percent = this.convertToPct({ left: x }, this.sWidth, this.sHeight)
      const { left, width } = this.layers[this.index]
      const l = left + percent.left
      const w = width - percent.left
      if (w > (2 * this.range / this.sWidth) && (l + width) < 1) {
        this.layers[this.index].left = l < 0 ? 0 : l
        this.layers[this.index].width = width - percent.left
      }
    },
    /**
     * 选框最右侧边的缩放方法 只与x轴移动有关
     * @author 郭世凯 2021-12-07
     * @param {number} x 移动的x距离
     * @param {number} y 移动的y距离
     */
    rectE (x, y) {
      const percent = this.convertToPct({ width: x }, this.sWidth, this.sHeight)
      const { left, width } = this.layers[this.index]
      const w = width + percent.width
      if (w > (2 * this.range / this.sWidth)) this.layers[this.index].width = w + left > 1 ? width : w
    }
  }
}
</script>

<style>
.selection-area{
  display: flex;
  align-items: center;
  justify-content: center;
}

.canvas-box {
  position: relative;
  text-align: center;
}

.canvas-painting{
  border: 1px solid #696;
  box-shadow: #666 0px 0px 10px;
  position: relative;
}

#operate-btn{
  position: absolute;
  top: 0;
  right: -60px;
}

.operate-btn {
  margin: 0 0 20px;
}
</style>
